import { render, staticRenderFns } from "./waiting-reconcile.vue?vue&type=template&id=959fb70a&scoped=true"
import script from "./waiting-reconcile.vue?vue&type=script&lang=js"
export * from "./waiting-reconcile.vue?vue&type=script&lang=js"
import style0 from "./waiting-reconcile.vue?vue&type=style&index=0&id=959fb70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959fb70a",
  null
  
)

export default component.exports